var {AmpersandState} = require('catalog/libs');
var FacetCollection = require('./hpe.productlist.facet.model');

/**
 * filterlist model
 * model hierarchy: filterlist (this) > facet > filtergroup > filter
 */
module.exports = AmpersandState.extend({

    /**
     * initialization
     */
    initialize: function() {

        //initial values used for desktop scolling
        this.scrollVals = {
            isAutoScrollBusy: false,
            isForceScrollPosition: false,
            isScrollTick: false,
            scrollTopPrevious: 0,
            scrollTopMostRecent: 0,
            yUpScrollPosition: 0,
            yBottomLock: 0,
            containerPositionedOffsetTop: 0
        };
    },

    props: {
        labelMobileOpen: 'string',
        labelMobileClose: 'string',
        labelClear: 'string',
        labelResults: 'string',
        totalMatches: 'number',
        totalFilters: 'number',
        facetCount: 'number',
        categoryCount: 'number',
        isMobile: ['boolean', false, false],
        isMobileNavOpen: ['boolean', false, false],
        isMobileNavTransitioning: ['boolean', false, false],
        scrollVals: 'object'
    },

    derived: {
        clearAllDisabled: {
            deps: ['totalFilters'],
            fn: function() {
                return (this.totalFilters > 0);
            }
        },
        shouldDisplay: {
            deps: ['facetCount', 'categoryCount'],
            cache: false,
            fn: function() {
                return !!((this.facetCount && (this.facetCount > 0)) || (this.categoryCount && (this.categoryCount > 0)));
            }
        }
    },

    collections: {
        facets: FacetCollection
    }
});
